<template>
    <v-card flat class="mx-0" >
        <v-card-text class="pa-0">
            <v-card class="white border-box ">
                <block v-if="loading"></block>
                <div class="my-3 " >
                    <v-row  class="ml-2 mx-2">
                                <v-col class="my-6 " cols="12" sm="12" md="6" lg="3">
                                    <date-picker label="Desde"
                                                 @dateSelected="(param) => (filterProducts.start = param)"
                                    ></date-picker>
                                </v-col>
                                <v-col class="my-6" cols="12" sm="12" md="6" lg="3">
                                    <date-picker label="Hasta"
                                                 @dateSelected="(param) => (filterProducts.end = param)"
                                    ></date-picker>
                                </v-col>
                                <v-col class="my-6" cols="12" sm="12" md="4" lg="2">
                                    <v-autocomplete outlined dense 
                                        v-model="filterProducts.warehouse"
                                        :items="warehouses"
                                        item-text="Warehouse"
                                       
                                        item-value="ID_Warehouse"
                                        label="Nombre de Almacen"
                                        attach
                                    ></v-autocomplete>
                                </v-col>
                                <v-col class="my-6 d-flex " cols="12" sm="12" md="4" lg="2">
                                    <v-btn @click="setClickedTrue(); getKardex(); isFilteredDate=true;" class="btn-save">Buscar</v-btn>
                                
                                    <v-btn  @click="clean" class="btnclean ml-1">Limpiar</v-btn>    
                                </v-col>

                            </v-row>
                </div>
                <v-btn style="margin-left: 10px" class="btn-save" @click="onExportingToPdf()">Exportar a pdf</v-btn>
                <v-btn style="margin-left: 10px" class="btn-save" @click="printDataKardex()">Kardex detallado (PDF)</v-btn>
                <GeneralFilter ref="generalFilter" :search="{}" :filterEndpoint="filterPromise" @filtered="filterHandler" @emptyFilter="clearFilter">
                    <DxDataGrid
                        ref="dataGrid"
                        :scrolling="{useNative:true}"
                        :data-source="!isFiltered ? products : productsListFiltered"
                        @exporting="onExporting"
                        :word-wrap-enabled="true" 
                    >
                        <DxExport :enabled="true" />
                        <!-- <DxColumn data-field="Pk_inventory_in_out" caption="PK_inventory"></DxColumn> -->
                        <DxColumn :width="60" cell-template="show-template" caption=""></DxColumn>
                        <DxColumn :width="100" data-field="SystemDateInsert"  caption="Fecha"></DxColumn>
                        <DxColumn :width="200" data-field="Inventory_ID_InvoicePurchaseOrder" caption="ID_Transaccion"></DxColumn> 
                        <DxColumn :width="columnWidth" data-field="MovType" caption="Tipo de movimiento"></DxColumn>
                        <DxColumn :width="columnWidth" data-field="Warehouse" caption="Almacen"></DxColumn>
                        <DxColumn :width="columnWidth" data-field="Item_InOut" caption="Entradas/Salidas"></DxColumn>
                        <DxColumn :width="columnWidth" data-field="QuantityIN" caption="Entradas"></DxColumn>
                        <DxColumn :width="columnWidth" data-field="QuantityOUT" caption="Salidas"></DxColumn>
                        <DxColumn v-if="KeyMaster != 'fa6646a6d6ef0c5f347a240270f49f38'" :width="columnWidth" data-field="Quantity" caption="Cantidad"></DxColumn>
                        <DxColumn :width="columnWidth" data-field="TotalStock" caption="Total de existencias"></DxColumn>

                        <template #show-template="{ data }">
                                <a href="#" class="mx-1" @click.prevent.stop="
                                showDetailtInvoice(data)
                                
                                ">
                                <v-icon color="primary">mdi-eye</v-icon>
                                </a>
                        </template>
                    
                    </DxDataGrid>
                </GeneralFilter>

            </v-card>
        </v-card-text>
        <v-dialog
                v-model="showBuyOrder"
                width ="60%"
        >
            <OrderDetails :key="Math.random()" :out="true" :order="order" v-if="showBuyOrder" @close="closeDialog"
            class="scroll-bar"></OrderDetails>
        </v-dialog>
        <v-dialog v-model="showInvoice" max-width="75%" >
            <v-card v-if="showInvoice">

                <invoice-details :hasPrintButtom="true" @close="showInvoice = false;" :invoice="order" :key="order.ID_Invoice"></invoice-details>
            </v-card>
        </v-dialog>
        <v-dialog v-model="showTransfer" max-width="1024px" scrollable>
            <TransferDetails :transferData="order" @close-modal="showTransfer = $event" />
        </v-dialog>
        <PrintKardexDetails :data="dataKardex" v-model="showPrintKardex"></PrintKardexDetails>
    </v-card>  
</template>

<script>
    import GeneralFilter from "@/components/GeneralFilter";
    import OrderDetails from "../PurchaseOrderDetails";
    import InvoiceDetails from "@/views/invoices/InvoiceDetails";
    import TransferDetails from "@/views/inventory/TransferDetails";
    import PrintKardexDetails from "@/components/ReportsAndPrintings/PrintKardexDetails";
    import {DxDataGrid, DxColumn, DxExport} from 'devextreme-vue/data-grid';
    import DatePicker from "@/components/DatePicker";
    import { printToExcel } from '@/helpers/printToexcel'
    import moment from 'moment';
    import { multipleCriteriaFilter } from '@/helpers/object'
    import { exportDataGrid } from 'devextreme/pdf_exporter';
    import { jsPDF } from 'jspdf'
    import 'jspdf-autotable';
    export default {
        name: "ProductKardex",
        props: ['data'],
        components: { 
            DxDataGrid, DxColumn, 
            DatePicker,
            DxExport, OrderDetails, 
            InvoiceDetails, TransferDetails,
            GeneralFilter,
            PrintKardexDetails,
        },
        data () {
            return {
                showPrintKardex: false,
                dataKardex: {
                    header: {},
                    data: [],
                },
                search: {
                    filter: null
                },
                products: null,
                filterProducts: {
                    start: null,
                    end: null,
                    warehouse: null,
                },
                warehouses: null,
                showBuyOrder: false,
                showInvoice: false,
                showTransfer: false,
                order: null,
                CurrentProvider: this.data,
                isFiltered: false,
                productsListFiltered: [],
                didHaveAllData: false,
                clicked: false,
                KeyMaster: JSON.parse(localStorage.getItem("user")).keymaster,
                isFilteredDate:false,
                loading:false,
            }
        },
        mounted() {
            this.getAllWarehouses();
           

        },
        computed:{
            columnWidth(){
                return this.$vuetify.breakpoint.smAndDown ? '150px':'auto !important'
            }
        },
        methods: {
            async printDataKardex() {
                try {
                    const dataStarFilter = this.filterProducts.start
                    const dataEndFilter = this.filterProducts.end
                    const warehouseSelected = this.warehouses.filter(w => w.ID_Warehouse == this.filterProducts.warehouse)[0]?.Warehouse || '';
                    this.dataKardex.data = await this.getKardex((this.isFilteredDate ? 1 : null), 2);                   
                    const { BusinessBillingNIT, BusinessBillingName, BusinessAddress } = await this.$API.business.FindOne(this.CurrentProvider.ID_Business)
                    this.dataKardex.header = {BusinessBillingNIT, BusinessBillingName, dataStarFilter, dataEndFilter, BusinessAddress, item: this.data, warehouse: warehouseSelected}
                    this.showPrintKardex = true
                } catch (err) {
                    console.error(err);
                }    
            },
            onExportingToPdf() {
                const doc = new jsPDF(); // Crear PDF en modo horizontal
                
                const lastPoint = { x: 0, y: 0 };

                exportDataGrid({
                    jsPDFDocument: doc,
                    component: this.$refs["dataGrid"].instance,
                    topLeft: { x: 0, y: 10 },
                    font: 9,
                    columnWidths: [0, 20, 35, 20, 25, 15, 15, 15, 15, 15],
                    customizeCell: function (options) {
                        options.pdfCell.font.size = 7;
                    },
                    customDrawCell({ rect }) {
                        if (lastPoint.x < rect.x + rect.w) {
                            lastPoint.x = rect.x + rect.w;
                        }
                        if (lastPoint.y < rect.y + rect.h) {
                            lastPoint.y = rect.y + rect.h;
                        }
                    },
                }).then(() => {
                    var pageCount = doc.internal.getNumberOfPages();
                    for(var i = 0; i < pageCount; i++){
                        doc.setPage(i);
                        let pageCurrent = doc.internal.getCurrentPageInfo().pageNumber;
                        doc.setFontSize(7)
                        doc.text ('page:  ' + pageCurrent + ' / ' + pageCount,10,10);

                        const header = 'Kardex del Producto ' + this.data.ID_Item;
                        const pageWidth = doc.internal.pageSize.getWidth();
                        const headerWidth = doc.getTextDimensions(header).w;
                        doc.setFontSize(10);
                        doc.text(header, (pageWidth - headerWidth) / 2, 10);
                    }
                    doc.save(`Reporte de Kardex del Producto ${this.data.ID_Item}.pdf`); // Guardar el archivo PDF
                }).catch(error => {
                    console.error('Error durante la exportación a PDF:', error); // Manejo de errores
                });
            },
            clean() {
                this.filterProducts = {
                    start: null,
                    end: null,
                    warehouse: null,
                }
                this.clicked = false;
                this.getKardex();
            },
            async getKardex(x=1, typeKardex = 1) { // typeKardex : 1 - Minimal | 2 - Complete 
                 this.loading = true;
                const params = {
                            itemid: this.data.ID_Item,
                            dateStart: (x && this.clicked) ? this.filterProducts.start : null,
                            dateEnd: (x && this.clicked) ? this.filterProducts.end : null,
                            warehouse: (x) || typeKardex === 2 ? this.filterProducts.warehouse : null,
                            typeKardex
                    };                
                if (typeKardex === 2) {
                    try {
                        return await this.$API.products.getKardexHistory(params);
                    } catch (error) {
                        console.log('Get Kardex', error);
                    }finally{
                        this.loading = false;
                    }
                     
                }else{
                    this.$API.products.getKardexHistory(params)
                        .then(response => {
                            let resp = response;
                            if (response.length > 0) {
                                resp = response.map((item) => {
                                    item.SystemDateInsert = moment(item.SystemDateInsert).format('YYYY-MM-DD');
                                    this.warehouses.forEach((warehouse) => {
                                        if (warehouse.ID_Warehouse === item.Warehouse) {
                                            item.Warehouse = warehouse.Warehouse;
                                        }
                                    })
                                    return item;
                                })
                            }
                            this.products = resp
                        
                    }).catch(err=>{
                        console.error('Kardex', err)
                    }).finally(()=>{
                        this.loading = false;
                    });
                }
            },
            getKardexAllList(x=1) {
                this.$API.products.getKardex({itemid: this.data.ID_Item,
                    dateStart: (x && this.clicked) ? this.filterProducts.start : null,
                    dateEnd: (x && this.clicked) ? this.filterProducts.end : null,
                    warehouse: (x) ? this.filterProducts.warehouse : null
                })
                    .then(response => {
                        let resp = response;
                        if (response.length > 0) {
                            resp = response.map((item) => {
                                item.SystemDateInsert = moment(item.SystemDateInsert).format('DD/MM/YYYY');
                                this.warehouses.forEach((warehouse) => {
                                    if (warehouse.ID_Warehouse === item.Warehouse) {
                                        item.Warehouse = warehouse.Warehouse;
                                    }
                                })
                                return item;
                            })
                        }
                        this.products = resp
                    })
            },
            getAllWarehouses() {
                this.$API.warehouse.getWarehouses()
                    .then(response => {
                    this.warehouses = response;
                    this.filterProducts.warehouse = this.warehouses.find( current => current.Active === true && parseInt(current.ID_Branch) === JSON.parse(localStorage.getItem("user")).branch ).ID_Warehouse;
                    this.getKardex();
                })
            },
            showDetailtInvoice(data) {
               if(data.data.Inventory_ID_InvoicePurchaseOrder.startsWith('PO')){
                    this.$API.orders.getOneOrder({
                        id: data.data.Inventory_ID_InvoicePurchaseOrder//,
                        // provider: this.CurrentProvider.ID_Provider
                    })
                    .then(response => {
                        if (response.PurchaseOrderPendingPayment == 1) response.orderStatus = 'Pendiente';
                        if (response.OrderProcessed== 1) response.orderStatus = 'Procesada';
                        this.order = {
                            ...data,
                            data : response,
                            
                        }
                        this.showBuyOrder = true;
                    })
               }
               else if(data.data.Inventory_ID_InvoicePurchaseOrder.startsWith('TFR')){
                this.$API.inventoryTransfer.getOneTransfer(data.data.Inventory_ID_InvoicePurchaseOrder).
                    then(response => {
                        this.order = {
                            
                            data : response,
                            
                        }
                        this.showTransfer = true;
                    })
                }
               else{
                this.$API.invoices.getInvoice(
                    data.data.Inventory_ID_InvoicePurchaseOrder
                )
                .then(response => {
                    this.order = response
                    this.showInvoice = true;
                })
               }
            },
            onExporting(e) {
                printToExcel(e, 'Kardex')
            },
            closeDialog() {
                this.showBuyOrder = false;
            },
            filterPromise(filterObj) {
                const filterArray =[
                    "SystemDateInsert",
                    "Inventory_ID_InvoicePurchaseOrder",
                    "MovType",
                    "Warehouse",
                    "Item_InOut",
                    "Quantity",
                    "TotalStock",
                ];
            return new Promise((resolve, reject) => {
                try {
                    resolve(multipleCriteriaFilter(filterArray, filterObj, this.products));
                } catch (error) {
                    reject(error);
                }})
            },
            clearFilter() {
                this.isFiltered = false;
            },
            filterHandler(response){
                if (response.length === 0 && this.didHaveAllData === false) {
                    this.didHaveAllData = true;
                    this.getKardexAllList();
                    this.$refs.generalFilter.filterHandler();
                }
                this.isFiltered = true
                this.productsListFiltered = response
            },
            setClickedTrue(){
                this.clicked = true;
            },
        },

    }
</script>

<style scoped>
.border-box {
    border-radius: 15px !important;
}
</style>
